import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./SyncErrorsList.module.css";
import SyncErrorItem from "../SynErrorItem";
import { useUsersData } from "DreamStream/UsersPage/useUsersData";

/**
 * View component. Scrollable list of sync errors with a header.
 */
export function SyncErrorsList({ errors }) {
  const { data, status } = useUsersData("users");

  const [usersData, setUsersData] = useState([errors]);

  // useEffect(() => {
  //   if (status === "success") {
  //     setUsersData([...data]);
  //   }
  // }, [data, status]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerGrid}>
          <div className={styles.headerItem}>IBO Name</div>
          <div className={styles.headerItem}>IBO #</div>
          <div className={styles.headerItem}>SYNC ERROR</div>
          <div className={styles.headerItem}>TIME OF ERROR</div>

          <div className={styles.headerItem}>STATUS</div>
        </div>

        <div className={styles.usersContainer}>
          {usersData.map((error, index) => (
            <div
              key={index}
              className={
                index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
              }
            >
              <SyncErrorItem
                errorInfo={{
                  name: error.name,
                  iboNum: error.iboNum,
                  syncError: error.syncError,
                  date: error.date,
                  time: error.time,
                  status: error.status,
                }}
                onClick={() => {
                  alert("Details clicked");
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

SyncErrorsList.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object),
};
